import { Outlet } from 'react-router-dom'
import Navbar from '@components/Navbar/Navbar'
import Toolbar from '@components/Toolbar/Toolbar'
import './SharedLayout.css'

/**
 * SharedLayout — layout dùng chung cho toàn bộ các trang.
 * Bao gồm Navbar cố định ở trên, Toolbar bên phải và <Outlet /> render nội dung từng trang.
 */
function SharedLayout() {
  return (
    <div className="shared-layout">
      <Navbar />
      <Toolbar />
      <main className="shared-layout__main">
        <Outlet />
      </main>
    </div>
  )
}

export default SharedLayout

